export const baseUrl = "//pupitres.net/pupitres-training-api/";

export default {
    baseUrl
}